import React from 'react'
import propTypes from 'prop-types'
import styled from '@emotion/styled';
import {theme} from '../../../themes/default-theme';
import Text from '../../typography';
import { ButtonBase } from '@mui/material';

const Container = styled.div`
`

const Items = styled.div`
    text-align: center;
    ${theme.breakpoints.up('md')} {
        display: flex;  
        margin: 0 auto;
        justify-content: center;
    }
`

const Item = styled(ButtonBase)`
    color: rgba(0,0,0,0.5);
    font-weight: bold;
    font-size: 16px;
    padding: 11px 17px;
    margin: 0 6px;
    border-radius: 20px;

    ${props => props.active && `
        background-color: ${theme.palette.gunmentalGrey};
        color: white;
    `}
`

const optionSelectDefaultPropItems = [];
const optionSelectDefaultPropOnChange = () => {};

const OptionSelect = ({
    items = optionSelectDefaultPropItems,
    onChange = optionSelectDefaultPropOnChange,
    activeIndex = 0
}) => {
    return (
    	<Container>
            <Items>
                {items.map((item, index) => {
                    return (
                        <div key={index}>
                            <Item active={index === activeIndex} onClick={() => onChange(item)}>
                                {item.text}
                            </Item>
                        </div>
                    )
                })}
            </Items>
        </Container>
    )
}

OptionSelect.propTypes = {

}

export default OptionSelect